/**
 * @param {HTMLElement} stockIndicator
 * @param {string|null|undefined} variantStock — numeric string from inventory, or empty when Shopify does not expose quantity
 * @param {boolean} variantAvailable — from variant JSON; when false, always show out of stock
 */
const updateStockIndicator = (stockIndicator, variantStock, variantAvailable = true) => {
  const threshold = Number(stockIndicator.dataset.lowStockThreshold);

  const messages = {
    instock: stockIndicator.querySelector('[data-stock-in-stock]'),
    lowstock: stockIndicator.querySelector('[data-stock-low-stock]'),
    oos: stockIndicator.querySelector('[data-stock-out-of-stock]')
  };

  const showMessage = key => {
    Object.entries(messages).forEach(([name, el]) => {
      el.classList.toggle('hidden', name !== key);
    });
  };

  if (!variantAvailable) {
    stockIndicator.dataset.stockAmount = '0';
    showMessage('oos');
    return;
  }

  const trimmed = variantStock == null ? '' : String(variantStock).trim();
  const raw = trimmed === '' ? NaN : Number(trimmed);
  const hasNumericQty = Number.isFinite(raw);

  if (!hasNumericQty) {
    stockIndicator.dataset.stockAmount = '';
    showMessage('instock');
    return;
  }

  stockIndicator.dataset.stockAmount = String(raw);

  if (raw <= 0) {
    showMessage('instock');
    return;
  }
  if (raw <= threshold) {
    showMessage('lowstock');
  } else {
    showMessage('instock');
  }
};

export default updateStockIndicator;
